import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, ChevronRight, Loader2, Shield, X as CloseIcon } from 'lucide-react';

/** Sticky-Mini-Cart oben rechts, sobald das Hero-Total aus dem Viewport gescrollt ist. */
export const StickyMiniCart = ({
  result, isPvt, cardName, cardImgFront, annualKm, vehicles,
  totalAmount, loading, fmt, onCheckout, onDismiss,
}) => (
  <div
    className="hidden md:block fixed top-4 right-4 sm:top-6 sm:right-6 z-50 w-[calc(100%-2rem)] sm:w-[400px] max-w-[400px] animate-in slide-in-from-top-4 fade-in duration-300"
    data-testid="sticky-mini-cart"
    role="region"
    aria-label="Schneller Warenkorb"
  >
    <div className="bg-white/95 backdrop-blur-md border border-stone-200 rounded-2xl shadow-[0_20px_60px_-10px_rgba(0,0,0,0.18)] overflow-hidden">
      <div className="flex items-center gap-3 p-3 sm:p-3.5">
        <div className="w-14 h-9 sm:w-16 sm:h-10 flex-shrink-0 rounded-md overflow-hidden bg-stone-950 flex items-center justify-center">
          <img
            src={cardImgFront}
            alt={cardName}
            className="w-full h-full object-contain"
            data-testid="sticky-mini-cart-thumb"
          />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[9px] uppercase tracking-[0.2em] text-stone-500 font-medium leading-none">
            {isPvt ? 'Privat' : 'Business'} · Warenkorb
          </p>
          <p className="text-xs sm:text-[13px] font-medium text-stone-900 truncate mt-0.5" data-testid="sticky-mini-cart-label">
            {cardName}
          </p>
          <p className="text-[10px] text-stone-500 leading-tight">
            {annualKm.toLocaleString('de-DE')} km{!isPvt ? ` · ${vehicles} Fzg` : ''}
          </p>
        </div>
        <div className="text-right flex-shrink-0">
          <p className="text-[9px] uppercase tracking-[0.18em] text-stone-500 leading-none">Gesamt</p>
          <p className="text-base sm:text-lg font-display tabular-nums text-stone-900 leading-tight" data-testid="sticky-mini-cart-total">
            {fmt(totalAmount)} €
          </p>
        </div>
        <button
          onClick={onDismiss}
          className="w-7 h-7 rounded-full hover:bg-stone-100 flex items-center justify-center text-stone-500 hover:text-stone-900 transition-colors flex-shrink-0"
          data-testid="sticky-mini-cart-close"
          aria-label="Mini-Cart schließen"
        >
          <CloseIcon className="w-3.5 h-3.5" strokeWidth={2} />
        </button>
      </div>
      <div className="border-t border-stone-100 px-3 pt-2 pb-3 sm:px-3.5">
        {result?.requires_inquiry ? (
          <Link
            to="/kontakt"
            className="w-full flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-full bg-stone-900 text-white text-xs font-medium hover:bg-stone-700 transition-colors"
            data-testid="sticky-mini-cart-inquiry"
          >
            Individuelle Anfrage <ChevronRight className="w-3.5 h-3.5" strokeWidth={2} />
          </Link>
        ) : (
          <button
            onClick={onCheckout}
            disabled={loading || !result}
            className={`w-full flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-full text-xs font-medium transition-colors ${
              isPvt ? 'bg-stone-900 text-white hover:bg-stone-700' : 'bg-yellow-400 text-stone-900 hover:bg-yellow-300'
            } disabled:opacity-60`}
            data-testid="sticky-mini-cart-buy"
          >
            {loading ? (
              <Loader2 className="w-3.5 h-3.5 animate-spin" strokeWidth={2} />
            ) : (
              <ShoppingCart className="w-3.5 h-3.5" strokeWidth={2} />
            )}
            In den Warenkorb · {fmt(totalAmount)} €
          </button>
        )}
        <p className="text-center text-[9px] text-stone-500 mt-1.5">
          <Shield className="w-2.5 h-2.5 inline mr-1" strokeWidth={2} />
          SSL · Virtuelle Card sofort aktiv · 14 Tage Widerruf
        </p>
      </div>
    </div>
  </div>
);
